// Retired: corner "viewfinder" ticks clashed with the homepage card style. Kept as a no-op so callers don't change.
export default function HudCorners() {
  return null;
}
